import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import AuthPage from "../../components/auth/AuthPage";
import OtpField from "../../components/auth/OtpField";
import SubmitButton from "../../components/auth/SubmitButton";
import { Button } from "../../components/ui/button";
import { API, ROLE_PASS } from "../../constant/api";
import { useAuth } from "../../context/auth-context";
import { getDeviceInfo } from "../../utils/device";
import { errorMessage } from "../../utils/errorMessage";
import sessionAxios from "../../utils/sessionAxios";

const AuthApp2Fa = () => {
  const { authenticate } = useAuth();
  const navigate = useNavigate();
  const { state: info } = useLocation() as any;
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");

  const verify = (code: string) => {
    if (loading) return;
    if (code.length !== 6) {
      toast.error("Enter all 6 digits");
      return;
    }
    setLoading(true);

    sessionAxios
      .post(API.completeLogin, {
        email: info?.email,
        password: info?.password,
        totp: code,
        deviceInfo: getDeviceInfo(),
        rolePass: ROLE_PASS,
      })
      .then((r: any) => {
        setLoading(false);
        toast.success("You are logged in. Happy trading!!!");
        authenticate().then(() => navigate(info?.from ?? "/dashboard"));
      })
      .catch((e: any) => {
        setLoading(false);
        toast.error(
          errorMessage(
            e?.response?.data?.message || "An error occurred during verification"
          )
        );
      });
  };

  return (
    <AuthPage
      title="2FA Authentication (Google Authenticator)"
      description="Kindly input the OTP from your authenticator app."
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          verify(otp);
        }}
        className="space-y-6"
      >
        <OtpField value={otp} onChange={setOtp} onComplete={verify} />

        <SubmitButton loading={loading}>Verify it's you</SubmitButton>

        {info?.emailAuth === true && info?.authApp === true && (
          <Button
            type="button"
            variant="link"
            onClick={() =>
              navigate("/auth-select", {
                state: {
                  email: info?.email,
                  password: info?.password,
                  from: info?.from,
                  authApp: info?.authApp,
                  emailAuth: info?.emailAuth,
                },
              })
            }
            className="h-auto w-full p-0 text-[14px] font-bold text-primary"
          >
            Try another method
          </Button>
        )}
      </form>
    </AuthPage>
  );
};

export default AuthApp2Fa;
